import { CustomerResetPasswordPage } from '@/pages/customer-portal/auth/CustomerResetPasswordPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
	token: z.string().optional(),
});

export const Route = createFileRoute('/customer/reset-password')({
	validateSearch: searchSchema,
	component: CustomerResetPasswordPage,
});
